import React, { useEffect, useState } from 'react';
import {
    Form,
    Row,
    Col,
    Card,
    Table,
    InputGroup,
    Image,
    Stack,
    Alert,
    Modal,
    Button,
    Spinner,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import {
    Eye,
    FileChartColumnIncreasing,
    BookPlus,
    LayoutList,
    ScanEye,
    FileText,
    UserSquare2,
} from 'lucide-react';
import { ADD, AXE, CYL, PD, SPH } from './options';
import config from '../../Api/config';
import EyeUpload from '../../Assets/Img/eye_upload.png';
import { toCamelCase } from '../../helper';
import { getSecureItem } from "../../utils/secureStorage";
const Preview = ({
    error,
    setAddEyeTestConfig,
    addEyeTestConfig,
    submit,
    handleChange,
    imageHandle,
    buttonLoading,
    setPreview,
    glass,
    view,
    eyeTestImages = {},
    images = {},
}) => {
    const { t } = useTranslation();
    const user = getSecureItem('UserData');

    useEffect(() => {
        console.log('addEyeTestConfig ======> ', addEyeTestConfig);
    }, [addEyeTestConfig]);

    console.log(eyeTestImages, 'eyeTestImageseyeTestImages');
    const selectValue = (index, item) => {
        return addEyeTestConfig?.testDetails[index - 1][item];
    };

    // Function to check if all medical fields are "None of the Above" or empty
    const checkAllNone = () => {
        const symptoms = addEyeTestConfig.symptoms
            ?.split(',')
            .filter((item) => item !== 'false');
        const diagnosed = addEyeTestConfig.dignosedwith
            ?.split(',')
            .filter((item) => item !== 'false');
        const conditions = addEyeTestConfig.healthConditions
            ?.split(',')
            .filter((item) => item !== 'false');

        return (
            (symptoms?.join(',') === 'None of the Above' ||
                !symptoms?.length) &&
            (diagnosed?.join(',') === 'None of the Above' ||
                !diagnosed?.length) &&
            (conditions?.join(',') === 'None of the Above' ||
                !conditions?.length)
        );
    };

    const allNone = checkAllNone();

    // Function to translate medical terms consistently with Step2
    const translateMedicalTerm = (term) => {
        if (!term) return '';
        return t(toCamelCase(term));
    };

    return (
        <Modal
            show={true}
            backdrop="static"
            size="lg"
            keyboard={false}
            centered
        >
            <Modal.Body className="p-4">
                <div className="d-flex align-items-center mb-3">
                    <i
                        className="bi bi-eye-fill text-primary me-2"
                        style={{ fontSize: '1.5rem' }}
                    ></i>
                    <h4 className="mb-0">Récapitulatif du test</h4>
                </div>

                <p className="text-muted mb-4">
                    Vérifiez les informations saisies avant l'envoi au médecin.
                </p>

                <div className="row g-3 mb-4">
                    {/* patient info */}
                    <div classname="col-md-12">
                        <div className="card h-100 border-warning bg-warning bg-opacity-10">
                            <div className="card-body">
                                <div className="form-check d-flex align-items-center">
                                    <label
                                        className="form-check-label fw-bold"
                                        htmlFor="patientInfo"
                                    >
                                        <UserSquare2
                                            size={25}
                                            className="me-2"
                                            color="#b38600"
                                        />{' '}
                                        Détails patient
                                    </label>
                                </div>
                                <div className="mt-2 ps-4">
                                    <div>
                                        <b>Nom :</b>{' '}
                                        {addEyeTestConfig.name || 'N/A'}{' '}
                                        {addEyeTestConfig.lastName || 'N/A'}
                                    </div>
                                    <div>
                                        <b>Email :</b>{' '}
                                        {addEyeTestConfig.patientEmail || 'N/A'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Final Optician Recommendation */}
                    <div className="col-md-12">
                        <div
                            className={`card h-100 ${
                                addEyeTestConfig.needPrescription
                                    ? 'border-primary bg-primary bg-opacity-10'
                                    : ''
                            }`}
                        >
                            <div className="card-body">
                                <div className="form-check d-flex align-items-center">
                                    <label
                                        className="form-check-label fw-bold"
                                        htmlFor="finalRecommendation"
                                    >
                                        <FileChartColumnIncreasing
                                            size={25}
                                            className="me-2"
                                            color="#3a02a2"
                                        />{' '}
                                        Prescription suggérée par l'opticien
                                    </label>
                                </div>
                                <div className="mt-2 ps-4">
                                    <div>
                                        <b>OD :</b> SPH{' '}
                                        {selectValue(7, 'sph') || 'N/A'}, CYL{' '}
                                        {selectValue(7, 'cyl') || 'N/A'}, AXE{' '}
                                        {selectValue(7, 'axe') || 'N/A'}, ADD{' '}
                                        {selectValue(7, 'add') || 'N/A'}
                                        {glass &&
                                            `, PD ${selectValue(7, 'pd') || 'N/A'}`}
                                    </div>
                                    <div className="my-1 border-t border--300"></div>{' '}
                                    {/* Added line with gap */}
                                    <div>
                                        <b>OG :</b> SPH{' '}
                                        {selectValue(8, 'sph') || 'N/A'}, CYL{' '}
                                        {selectValue(8, 'cyl') || 'N/A'}, AXE{' '}
                                        {selectValue(8, 'axe') || 'N/A'}, ADD{' '}
                                        {selectValue(8, 'add') || 'N/A'}
                                        {glass &&
                                            `, PD ${selectValue(8, 'pd') || 'N/A'}`}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Visual Acuity */}
                    <div className="col-md-12">
                        <div className="card h-100 border-success bg-success bg-opacity-10">
                            <div className="card-body">
                                <div className="form-check d-flex align-items-center">
                                    <label
                                        className="form-check-label fw-bold"
                                        htmlFor="visualAcuity"
                                    >
                                        <Eye
                                            size={25}
                                            className="me-2"
                                            color="#41ab07"
                                        />{' '}
                                        Données de l'examen
                                    </label>
                                </div>
                                <div className="mt-2 ps-4">
                                    <label
                                        className="form-check-label fw-bold"
                                        htmlFor="freeAct"
                                    >
                                        Symptômes :
                                    </label>
                                    {allNone ? (
                                        <div>N/A</div>
                                    ) : (
                                        <>
                                            <div>
                                                <b>Symptômes :</b>{' '}
                                                {addEyeTestConfig.symptoms
                                                    ?.split(',')
                                                    .map((item) => item.trim())
                                                    .filter(
                                                        (item) =>
                                                            item &&
                                                            item.toLowerCase() !==
                                                                'false'
                                                    )
                                                    .map((item) =>
                                                        translateMedicalTerm(
                                                            item
                                                        )
                                                    )
                                                    .join(', ') || 'N/A'}
                                            </div>
                                            <div>
                                                <b>Diagnostics :</b>{' '}
                                                {addEyeTestConfig.dignosedwith
                                                    ?.split(',')
                                                    .map((item) => item.trim())
                                                    .filter(
                                                        (item) =>
                                                            item &&
                                                            item.toLowerCase() !==
                                                                'false'
                                                    )
                                                    .map((item) =>
                                                        translateMedicalTerm(
                                                            item
                                                        )
                                                    )
                                                    .join(', ') || 'N/A'}
                                            </div>
                                            <div>
                                                <b>Conditions de santé :</b>{' '}
                                                {addEyeTestConfig.healthConditions
                                                    ?.split(',')
                                                    .map((item) => item.trim())
                                                    .filter(
                                                        (item) =>
                                                            item &&
                                                            item.toLowerCase() !==
                                                                'false'
                                                    )
                                                    .map((item) =>
                                                        translateMedicalTerm(
                                                            item
                                                        )
                                                    )
                                                    .join(', ') || 'N/A'}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className="mt-2 ps-4">
                                    <div>
                                        <b>Acuité près : </b> OD{' '}
                                        {addEyeTestConfig.info_Acuity_Near_Vision_Right_Eye ||
                                            'N/A'}
                                        , OG{' '}
                                        {addEyeTestConfig.info_Acuity_Near_Vision_Left_Eye ||
                                            'N/A'}
                                        ,
                                    </div>
                                    <div>
                                        <b>Acuité loin :</b> OD{' '}
                                        {addEyeTestConfig.info_Acuity_Distance_Vision_Right_Eye ||
                                            'N/A'}
                                        , OG{' '}
                                        {addEyeTestConfig.info_Acuity_Distance_Vision_Left_Eye ||
                                            'N/A'}
                                        ,
                                    </div>
                                    <div>
                                        <b>Acuité sans correction de loin : </b>{' '}
                                        OD{' '}
                                        {addEyeTestConfig.info_Acuity_visual_sans_correction_Right_Eye ||
                                            'N/A'}
                                        , OG{' '}
                                        {addEyeTestConfig.info_Acuity_visual_sans_correction_Left_Eye ||
                                            'N/A'}
                                        ,
                                    </div>
                                    <div>
                                        <b>PIO :</b> OD{' '}
                                        {addEyeTestConfig.info_Eye_Pressure_Right_Eye ||
                                            'N/A'}
                                        , OG{' '}
                                        {addEyeTestConfig.info_Eye_Pressure_Left_Eye ||
                                            'N/A'}
                                        ,
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Other Information */}
                    <div className="col-md-12">
                        <div className="card h-100 border-info bg-info bg-opacity-10">
                            <div className="card-body">
                                <div className="form-check d-flex align-items-center">
                                    <label
                                        className="form-check-label fw-bold"
                                        htmlFor="otherInfo"
                                    >
                                        <LayoutList
                                            size={25}
                                            className="me-2"
                                            color="#5a8c7f"
                                        />{' '}
                                        Autres informations
                                    </label>
                                </div>
                                <div className="mt-2 ps-4">
                                    {addEyeTestConfig.acteGratuit && (
                                        <div>
                                            <b>Acte gratuit :</b>{' '}
                                            {addEyeTestConfig.acteGratuit
                                                ? 'Oui'
                                                : 'Oui'}
                                        </div>
                                    )}
                                    <div>
                                        <b>Ordonnance requise :</b>{' '}
                                        {addEyeTestConfig.needPrescription
                                            ? 'Oui'
                                            : 'Non'}
                                    </div>
                                    {addEyeTestConfig.isImageRetino ===
                                        'Yes'?
                                    <div>
                                        <b>Images retino :</b>{' '}
                                        {addEyeTestConfig.isImageRetino ===
                                        'Yes'
                                            ? 'Oui'
                                            : 'Non'}
                                    </div>:null}
                                    {user?.isOpticianExpressAccess === true && (
                                        <div>
                                            <b>
                                                Service téléexpertise express :
                                            </b>{' '}
                                            {addEyeTestConfig.isExpressTest ===
                                            true
                                                ? 'Oui'
                                                : 'Non'}
                                        </div>
                                    )}

                                    {/* {addEyeTestConfig.isExpressTest && (
                                        <div>
                                            <b>
                                                Service téléexpertise express :
                                            </b>{' '}
                                            {addEyeTestConfig.isExpressTest ===
                                            true
                                                ? 'Oui'
                                                : 'Non'}
                                        </div>
                                    )} */}
                                    {addEyeTestConfig.commentsForPrescription && (
                                        <div>
                                            <b>À noter sur l'ordonnance :</b>{' '}
                                            {
                                                addEyeTestConfig.commentsForPrescription
                                            }
                                        </div>
                                    )}
                                    {addEyeTestConfig.noteOpt && (
                                        <div>
                                            <b>
                                                Contexte pour l'ophtalmologue
                                                (recommandé) :
                                            </b>{' '}
                                            {addEyeTestConfig.noteOpt}
                                        </div>
                                    )}
                                    {addEyeTestConfig.commentForLenses && (
                                        <div>
                                            <b>Spécification lentilles :</b>{' '}
                                            {addEyeTestConfig.commentForLenses}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Retinal Images */}
                {/* Only show the Images section if at least one image exists */}
                {(eyeTestImages.eyeTestImagePath1 ||
                    eyeTestImages.eyeTestImagePath2 ||
                    eyeTestImages.eyeTestImagePath3 ||
                    images.image1_preview ||
                    images.image2_preview ||
                    images.image3_preview) && (
                    <div className="card mb-4 border-dark bg-dark-soft">
                        <div className="card-body">
                            <div className="form-check d-flex align-items-center">
                                <label
                                    className="form-check-label fw-bold"
                                    htmlFor="retinalImages"
                                >
                                    <ScanEye
                                        size={25}
                                        className="me-2"
                                        color="#f00534"
                                    />
                                    Images
                                </label>
                            </div>
                            <div className="mt-2 ps-4">
                                <div className="row g-3">
                                    {eyeTestImages.eyeTestImagePath1 ||
                                    images.image1_preview ? (
                                        <div className="col-md-4">
                                            <div className="card h-100">
                                                <div className="card-body text-center">
                                                    <h6 className="card-subtitle mb-2 text-muted">
                                                        Ancienne ordonnance
                                                        lentilles
                                                    </h6>
                                                    <a
                                                        href={`${config.API_URL}/${eyeTestImages.eyeTestImagePath1}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {eyeTestImages.eyeTestImagePath1 ? (
                                                            eyeTestImages.eyeTestImagePath1
                                                                .toLowerCase()
                                                                .endsWith(
                                                                    '.pdf'
                                                                ) ? (
                                                                <div className="pdf-preview">
                                                                    <i
                                                                        className="fas fa-file-pdf"
                                                                        style={{
                                                                            fontSize:
                                                                                '50px',
                                                                            color: 'red',
                                                                        }}
                                                                    >
                                                                        {' '}
                                                                        <FileText
                                                                            size={
                                                                                60
                                                                            }
                                                                            className="me-2"
                                                                            color="#051df0ff"
                                                                        />
                                                                    </i>
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={`${config.API_URL}/${eyeTestImages.eyeTestImagePath1}`}
                                                                    className="img-fluid rounded"
                                                                    alt="Eye test"
                                                                    style={{
                                                                        maxHeight:
                                                                            '150px',
                                                                    }}
                                                                    onError={(
                                                                        e
                                                                    ) => {
                                                                        e.target.style.display =
                                                                            'none';
                                                                        e.target.nextSibling.style.display =
                                                                            'block';
                                                                    }}
                                                                />
                                                            )
                                                        ) : (
                                                            <img
                                                                src={
                                                                    images.image1_preview
                                                                }
                                                                className="img-fluid rounded"
                                                                alt="Eye test"
                                                                style={{
                                                                    maxHeight:
                                                                        '150px',
                                                                }}
                                                                onError={(
                                                                    e
                                                                ) => {
                                                                    e.target.style.display =
                                                                        'none';
                                                                    e.target.nextSibling.style.display =
                                                                        'block';
                                                                }}
                                                            />
                                                        )}

                                                        {/* Fallback PDF icon for broken images */}
                                                        <i
                                                            className="fas fa-file-pdf"
                                                            style={{
                                                                fontSize:
                                                                    '50px',
                                                                color: 'red',
                                                                display: 'none',
                                                            }}
                                                            onError={(e) => {
                                                                e.target.style.display =
                                                                    'block';
                                                            }}
                                                        >
                                                            {' '}
                                                            <FileText
                                                                size={60}
                                                                className="me-2"
                                                                color="#051df0ff"
                                                            />
                                                        </i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {eyeTestImages.eyeTestImagePath2 ||
                                    images.image2_preview ? (
                                        <div className="col-md-4">
                                            <div className="card h-100">
                                                <div className="card-body text-center">
                                                    <h6 className="card-subtitle mb-2 text-muted">
                                                        Fond d'oeil OD
                                                    </h6>
                                                    <a
                                                        href={`${config.API_URL}/${eyeTestImages.eyeTestImagePath2}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img
                                                            src={
                                                                eyeTestImages.eyeTestImagePath2
                                                                    ? `${config.API_URL}/${eyeTestImages.eyeTestImagePath2}`
                                                                    : images.image2_preview
                                                            }
                                                            className="img-fluid rounded"
                                                            alt="Right eye"
                                                            style={{
                                                                maxHeight:
                                                                    '150px',
                                                            }}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {eyeTestImages.eyeTestImagePath3 ||
                                    images.image3_preview ? (
                                        <div className="col-md-4">
                                            <div className="card h-100">
                                                <div className="card-body text-center">
                                                    <h6 className="card-subtitle mb-2 text-muted">
                                                        Fond d'oeil OG
                                                    </h6>
                                                    <a
                                                        href={`${config.API_URL}/${eyeTestImages.eyeTestImagePath3}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img
                                                            src={
                                                                eyeTestImages.eyeTestImagePath3
                                                                    ? `${config.API_URL}/${eyeTestImages.eyeTestImagePath3}`
                                                                    : images.image3_preview
                                                            }
                                                            className="img-fluid rounded"
                                                            alt="Left eye"
                                                            style={{
                                                                maxHeight:
                                                                    '150px',
                                                            }}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Buttons */}
                <div className="d-flex justify-content-between mt-4">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => setPreview(false)}
                    >
                        <i className="bi bi-arrow-left me-2"></i>Retour
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={submit}
                        disabled={buttonLoading}
                    >
                        {buttonLoading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Envoi en cours...
                            </>
                        ) : (
                            <>
                                <i className="bi bi-check-circle me-2"></i>
                                Confirmer et envoyer
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default Preview;
